import React, { useEffect } from 'react';
import { useWebsiteSettings } from '../../contexts/WebsiteSettingsContext';

export default function ThemeInjector() {
  const { settings, theme, loading } = useWebsiteSettings();

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--color-primary', theme.primaryColor || '#2563eb');
    root.style.setProperty('--color-secondary', theme.secondaryColor || '#1e40af');
    root.style.setProperty('--color-accent', theme.accentColor || '#f59e0b');
    return () => {
      root.style.removeProperty('--color-primary');
      root.style.removeProperty('--color-secondary');
      root.style.removeProperty('--color-accent');
    };
  }, [theme.primaryColor, theme.secondaryColor, theme.accentColor]);

  useEffect(() => {
    if (loading || !settings) return;
    const faviconUrl = settings?.content?.favicon || settings?.theme?.favicon;
    const existing = document.querySelector('link[rel="icon"]');
    if (faviconUrl) {
      const link = existing || document.createElement('link');
      link.rel = 'icon';
      link.href = faviconUrl;
      if (!existing) document.head.appendChild(link);
    } else if (existing) {
      existing.remove();
    }
  }, [loading, settings?.content?.favicon, settings?.theme?.favicon]);

  useEffect(() => {
    if (loading || !settings) return;
    const ogUrl = settings?.theme?.ogImage;
    const existing = document.querySelector('meta[property="og:image"]');
    if (ogUrl) {
      const meta = existing || document.createElement('meta');
      meta.setAttribute('property', 'og:image');
      meta.content = ogUrl;
      if (!existing) document.head.appendChild(meta);
    }
  }, [loading, settings?.theme?.ogImage]);

  return null;
}
